"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerServicePlatformEnum = exports.CustomerServiceFromEnum = exports.CustomerServiceSceneEnum = void 0;
var CustomerServiceSceneEnum;
(function (CustomerServiceSceneEnum) {
    /** 账号安全限制 */
    CustomerServiceSceneEnum["AccountRiskVerify"] = "1";
    /** 账号解封 */
    CustomerServiceSceneEnum["AccountUnblocked"] = "2";
})(CustomerServiceSceneEnum = exports.CustomerServiceSceneEnum || (exports.CustomerServiceSceneEnum = {}));
var CustomerServiceFromEnum;
(function (CustomerServiceFromEnum) {
    /** 账号安全限制 */
    CustomerServiceFromEnum["AccountRiskVerify"] = "wemeet-login-verify";
    /** 账号解封 */
    CustomerServiceFromEnum["AccountUnblocked"] = "wemeet-login-block";
})(CustomerServiceFromEnum = exports.CustomerServiceFromEnum || (exports.CustomerServiceFromEnum = {}));
var CustomerServicePlatformEnum;
(function (CustomerServicePlatformEnum) {
    CustomerServicePlatformEnum[CustomerServicePlatformEnum["Client"] = 0] = "Client";
    CustomerServicePlatformEnum[CustomerServicePlatformEnum["ClientM"] = 1] = "ClientM";
    CustomerServicePlatformEnum[CustomerServicePlatformEnum["Web"] = 2] = "Web";
    CustomerServicePlatformEnum[CustomerServicePlatformEnum["WebM"] = 3] = "WebM";
})(CustomerServicePlatformEnum = exports.CustomerServicePlatformEnum || (exports.CustomerServicePlatformEnum = {}));
//# sourceMappingURL=go-to-cusomer-service.js.map